import React from 'react';
import i18n from '../../i18n';
import {withFormik} from 'formik';
import axios from 'axios';
import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";
import FormField from "../Form/FormField";
import Grid from "@material-ui/core/Grid/Grid";
import {withStyles} from "@material-ui/core";
import {mergeWithDefault} from "../Form/utils";
import FormCheck from "../Form/FormCheck";
import swal from "sweetalert";
import FormAutocomplete from "../Form/FormAutocomplete";
import {array, object, string} from "yup";
import DeleteButton from "../Form/DeleteButton";
import FormSelect from "../Form/FormSelect";

class CustomerFormFields extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showCompany: false
        };
    }

    toggleCompany(e) {
        this.props.handleChange(e);
        this.state.showCompany = ! this.state.showCompany;
    }

    render() {
        const {
            values,
            touched,
            errors,
            handleChange,
            handleBlur,
            handleSubmit,
            contactType,
            setFieldValue,
            formUrl,
            isEdit
        } = this.props;

        return (
            <form
                method="POST"
                url={formUrl}
                onSubmit={handleSubmit}
            >

                <input type="hidden" name="contact_type" value={values.contact_type} onChange={handleChange}/>

                <Grid container spacing={24}>
                    <Grid item xs={9}>
                        <FormField
                            type="text"
                            name="customer_name"
                            label={i18n.get('boards.board_name')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.customer_name}
                            error={errors.customer_name}
                            touched={touched.customer_name}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <FormField
                            type="text"
                            name="customer_number"
                            label={i18n.get('boards.customer_number')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.customer_number}
                            error={errors.customer_number}
                            touched={touched.customer_number}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <FormSelect
                            type="text"
                            name="salutation"
                            label={i18n.get('boards.salutation')}
                            onChange={option => setFieldValue('salutation', option.value)}
                            onBlur={handleBlur}
                            value={values.salutation}
                            error={errors.salutation}
                            touched={touched.salutation}
                            options={[
                                {label: 'Herr', value: 'Herr'},
                                {label: 'Frau', value: 'Frau'}
                            ]}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <FormField
                            type="text"
                            name="first_name"
                            label={i18n.get('boards.first_name')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.first_name}
                            error={errors.first_name}
                            touched={touched.first_name}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <FormField
                            type="text"
                            name="last_name"
                            label={i18n.get('boards.last_name')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.last_name}
                            error={errors.last_name}
                            touched={touched.last_name}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={24}>
                    <Grid item xs={12} sm={6} md={4}>
                        <FormField
                            type="text"
                            name="street"
                            label={i18n.get('boards.street')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.street}
                            error={errors.street}
                            touched={touched.street}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                        <FormField
                            type="text"
                            name="housenumber"
                            label={i18n.get('boards.housenumber')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.housenumber}
                            error={errors.housenumber}
                            touched={touched.housenumber}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                        <FormField
                            type="text"
                            name="zip"
                            label={i18n.get('boards.zip')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.zip}
                            error={errors.zip}
                            touched={touched.zip}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <FormField
                            type="text"
                            name="city"
                            label={i18n.get('boards.city')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.city}
                            error={errors.city}
                            touched={touched.city}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={24}>
                    <Grid item xs={12} sm={4}>
                        <FormField
                            type="text"
                            name="telephone"
                            label={i18n.get('boards.telephone')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.telephone}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <FormField
                            type="email"
                            name="email"
                            label={i18n.get('boards.email')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.email}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <FormField
                            type="text"
                            name="website"
                            label={i18n.get('boards.website')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.website}
                        />
                    </Grid>
                </Grid>

                <Grid container spacing={24} justify="space-between" alignItems="center" style={{paddingTop: 8}}>
                    <Grid item>
                        &nbsp;
                    </Grid>
                    <Grid item>
                        <Button size="small"
                                variant="contained"
                                color="primary"
                                type="submit"
                        >
                            {isEdit ?
                                (<Icon fontSize="small">refresh</Icon>) :
                                (<Icon fontSize="small">save</Icon>)
                            } &nbsp;
                            {isEdit ? i18n.get('boards.update') : i18n.get('boards.save')}
                        </Button>
                    </Grid>
                </Grid>
            </form>
        )
    }
}

export default CustomerFormFields



// WEBPACK FOOTER //
// ./resources/assets/js/components/Customers/CustomerFormFields.js